import { render, staticRenderFns } from "./ControlMenuPatternLabForm.vue?vue&type=template&id=71dbf4b2&scoped=true&"
import script from "./ControlMenuPatternLabForm.vue?vue&type=script&lang=js&"
export * from "./ControlMenuPatternLabForm.vue?vue&type=script&lang=js&"
import style0 from "./ControlMenuPatternLabForm.vue?vue&type=style&index=0&id=71dbf4b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dbf4b2",
  null
  
)

export default component.exports